import React from 'react'
import { Modal, Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'

const InboundHelpModal = ({ visible, onClose }) => {
  const apiUrl = process.env.REACT_APP_API_URL || ''
  const downloadPdfUrl = `${apiUrl}${apiUrl && !apiUrl.endsWith('/') ? '/' : ''}download_summary_pdf?module=inbound-flight`

  return (
    <Modal
      title={
        <div className='inbound-help-header'>
          <span className='inbound-help-header-title'>Inbound Flight Preparation Summary</span>
        </div>
      }
      open={visible}
      visible={visible}
      onCancel={onClose}
      centered
      footer={[
        <a key='download' href={downloadPdfUrl} download='Inbound summary.pdf'>
          <Button type='primary' className='inbound-help-download-btn' icon={<DownloadOutlined />}>
            Download PDF
          </Button>
        </a>
      ]}
      width={780}
      className='custom-modal inbound-help-modal'
    >
      <div className='inbound-help-content'>
        <div className='inbound-help-card'>
          <div className='inbound-help-title'>Inbound Flight Preparation</div>
          <p>
            The Inbound Flight Preparation page displays all inbound flights which are carrying cargo. It allows users to handle shipments which are not meeting the defined handling times. This can be done before the flight even arrives into the station. By default flights arriving in a 6-hr window from current time will be displayed. Users can change this by manipulating the date &amp; time filter. The applicable parameters for this page is the Handling times, Breakdown Workarea mapping (for assigning &apos;Deliver To&apos;) &amp; Recovery Actions (for displaying the recovery actions) from the System Parameters module.
          </p>
        </div>

        <div className='inbound-help-card'>
          <div className='inbound-help-title'>Conditions to Add</div>
          <p>
            Flights are added to the Inbound Flight Preparation page once the Hub Control System receives an incoming flight manifest. Flights arriving with a NIL manifest will not be displayed on the inbound screen.
          </p>
        </div>

        <div className='inbound-help-card'>
          <div className='inbound-help-title'>Conditions to Remove</div>
          <p>Flights are removed from the Inbound page in two ways :</p>
          <ul className='inbound-help-list'>
            <li>Once the flight falls out of the 6-hr window</li>
            <li>
              Once all shipments arriving on the flight receive an RCF message. This marks the Flight as &apos;Complete&apos;. Completed flights are not shown on the main list but will be displayed once the user clicks the &apos;Show Completed Flights&apos; checkbox.
            </li>
          </ul>
        </div>

        <div className='inbound-help-card'>
          <div className='inbound-help-title'>Order by</div>
          <p>
            The incoming flights are ordered by the TTA (Time to Arrival), with the earliest arriving flight displayed at the top of the list. For the ULD &amp; AWB section, the ULD/AWBs are sorted by the Handling Time remaining, with the least Handling time displayed at the top.
          </p>
        </div>

        <div className='inbound-help-card'>
          <div className='inbound-help-title'>Filters</div>
          <p>
            The flights data can be filtered to display only green or red flights by using the &apos;Show Green Flights&apos; or &apos;Show Red Flights&apos; checkboxes. As mentioned above, &apos;Show Completed&apos; checkbox displays all completed flights within the time frame selected.
          </p>
        </div>

        <div className='inbound-help-card'>
          <div className='inbound-help-title'>Comments</div>
          <ul className='inbound-help-list'>
            <li>
              <strong>AWB Status indicator :</strong> the colour indicator on an AWB level is driven by the Handling time remaining for the AWB. If the handling time cannot be met, the AWB status colour will be <span className='inbound-text-red'>Red</span>. Additionally, if the booking is unconfirmed the AWB status colour will be <span className='inbound-text-red'>Red</span>.
            </li>
            <li>
              <strong>ULD Status indicator :</strong> if one or more AWBs nested in the ULD are red, then the ULD status indicator will turn <span className='inbound-text-red'>Red</span>. This in turn changes the flight level indicator to <span className='inbound-text-red'>Red</span> as well.
            </li>
          </ul>
        </div>
      </div>
    </Modal>
  )
}

export default InboundHelpModal
